import './styles.scss'
import * as React from 'react'
import { SketchPicker } from 'react-color'
import { Popover, PopoverBody } from 'reactstrap'

const primaryColor = '#E87721'

const ColorPickerInput = ({ color, setColor }) => {
  const [pickerOpen, setPickerOpen] = React.useState(false)

  return (
    <div className='color-selector'>
      <input value={color || primaryColor} readOnly={true} />
      <div id='colorPopover' className='color-picker' style={{ backgroundColor: color || primaryColor }} onClick={() => setPickerOpen(!pickerOpen)} />
      <Popover
        placement="right"
        isOpen={pickerOpen}
        target="colorPopover"
        toggle={() => setPickerOpen(!pickerOpen)}
        className='popover-color-picker'
        trigger='legacy'
      >
        <PopoverBody>
          <SketchPicker color={color || primaryColor} onChange={value => setColor(value.hex)} />
        </PopoverBody>
      </Popover>
    </div>
  )
}

export default ColorPickerInput